import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import { sysLogin } from "@/api/api-basic";
import sha256 from "js-sha256";
import i18n from "@/config/i18n";
let PiLogin = class PiLogin extends Vue {
    constructor() {
        super(...arguments);
        this.test = "light";
        this.loading = false;
        this.formInline = {
            userName: "",
            password: "",
            loginType: "0",
            subSystemPkId: "1",
            verCode: "",
            changeLang: "",
        };
        this.ruleInline = {
            userName: [
                {
                    required: true,
                    message: i18n.t("login.userNamePl"),
                    trigger: "blur",
                },
            ],
            password: [
                {
                    required: true,
                    message: i18n.t("login.passwordPl"),
                    trigger: "blur",
                },
                {
                    type: "string",
                    min: 6,
                    message: i18n.t("login.passwordError"),
                    trigger: "blur",
                },
            ],
        };
        this.changeLangList = [
            {
                value: "zh-CN",
                label: "简体中文",
            },
            {
                value: "en-US",
                label: "English",
            },
        ];
    }
    changeLangFn(val) {
        this.$i18n.locale = val;
        sessionStorage.setItem("language", val);
        location.reload();
    }
    handleSubmit() {
        const eleSub = this.$refs["formInline"] || {};
        eleSub.validate((valid) => {
            if (valid) {
                this.submitData();
            }
        });
    }
    async submitData() {
        const json = JSON.parse(JSON.stringify(this.formInline));
        json.password = sha256.sha256(json.password);
        this.loading = true;
        const ret = await sysLogin(json);
        if (ret.status == this.$config.apiStatus) {
            this.$common.save("sys_loginData", ret.data[0]);
            this.$router.push("/").catch(() => {
                console.log("");
            });
        }
        this.loading = false;
    }
    mounted() {
        document.onkeydown = (event) => {
            if (event.keyCode === 13 && !this.loading) {
                this.handleSubmit();
                return false;
            }
        };
        this.formInline.changeLang = this.$i18n.locale;
    }
    destroyed() {
        document.onkeydown = null;
    }
};
PiLogin = __decorate([
    Component
], PiLogin);
export default PiLogin;
